module.exports = __webpack_public_path__ + "static/media/4ODA2.2993b913.jpg";